module.exports = __webpack_public_path__ + "img/cartracker_logo.0cfae8f1.png";